/* ==========================================================================
   CONTACT — Kim's Sourdough
   ========================================================================== */

(function () {
  var params = new URLSearchParams(window.location.search);
  var requestedProduct = params.get('request');
  var message = document.getElementById('KsContactForm-body');

  if (!requestedProduct || !message || message.value.trim()) return;

  message.value = [
    'Hi Kim,',
    '',
    "I'd like to request " + requestedProduct + '. Please let me know if it can be included in an upcoming bake.',
    '',
    'Thanks!'
  ].join('\n');
})();
